import CustomTextField from 'components/Input/CustomTextField';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { SET_SITE_VALIDATION, UPDATE_FORM_VALIDITY } from 'store/key';
import styled from 'styled-components/macro';
import { produce } from 'utility/general';
import NumberListFormItem from '../NumberListFormItem';

const SLayout = styled.div``;

const StudyDetailForProspectiveStudySiteInfo = ({
    getSiteData = () => null,
    onSiteFieldChange = () => null,
    disableOnPermission = false,
    siteInfoId = -1,
    applicationDetail = {},
    isProspective,
    formId = -1,
    isHighlight,
}) => {
    const [siteInfoValidation, setSiteInfoValidation] = useState({});

    const validationKey = 'studyDetailsForProspectiveStudy';

    const isSiteValid = useSelector(
        (state) => state.applicationDetailValid.siteInfoValid?.[siteInfoId]?.[validationKey],
    );

    const dispatch = useDispatch();

    // update site-info validity to the reducer
    useEffect(() => {
        const validations = Object.values(siteInfoValidation);

        // data is not initialized
        if (validations.length === 0) {
            return;
        }

        const currentStatus = validations.every((item) => item);

        if (currentStatus !== isSiteValid) {
            dispatch({
                type: UPDATE_FORM_VALIDITY,
                payload: {
                    type: 'site',
                    applicationFormId: formId,
                    siteInfoId: siteInfoId,
                    formKey: validationKey,
                    isValid: currentStatus,
                },
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteInfoValidation]);

    const updateSiteValidation = (name, isValidate) => {
        setSiteInfoValidation(
            produce((draft) => {
                if (!isProspective) {
                    draft[name] = true;
                } else {
                    draft[name] = isValidate;
                }
            }),
        );
    };

    // when siteInfoValidation change, update the reducer
    useEffect(() => {
        dispatch({
            type: SET_SITE_VALIDATION,
            payload: {
                siteInfoId,
                [validationKey]: siteInfoValidation,
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteInfoValidation]);

    return (
        <SLayout>
            <NumberListFormItem number={'11.3'} highlight={isHighlight(['p2NumOfExtra'])}
                commentProps={{ 
                    commentLabel: '11.3 Number of extra visits / admission on top of usual care', 
                    commentStatus: null,
                }}
            >
                <CustomTextField
                    disableOnPermission={disableOnPermission}
                    key={`p2NumOfExtra${siteInfoId}`}
                    value={getSiteData('p2NumOfExtra')}
                    name={'p2NumOfExtra'}
                    debounceChange
                    maxLength={255}
                    allowAction={isProspective}
                    onChange={onSiteFieldChange}
                    onAppFieldValidate={updateSiteValidation}
                    label={'Number of extra visits / admission on top of usual care'}
                />
            </NumberListFormItem>
            <NumberListFormItem
                disableOnPermission={disableOnPermission}
                key={`p2OtherInvestigator${siteInfoId}`}
                number={'11.4'}
                label={
                    'Will any of the study interventions / procedures be performed by persons other than the investigators?'
                }
                showTrueFalse
                allowAction={isProspective}
                displayContentNextLine
                disableVerticalCenter
                onAppFieldValidate={updateSiteValidation}
                trueFalseValue={getSiteData('p2OtherInvestigator')}
                name={'p2OtherInvestigator'}
                onTrueFalseSelected={onSiteFieldChange}
                highlight={isHighlight(['p2OtherInvestigator'])}
                commentProps={{ 
                    commentLabel: '11.4 Will any of the study interventions / procedures be performed by persons other than the investigators?', 
                    commentStatus: null,
                }}
            />
            <NumberListFormItem number={'11.4.1'} level={2} highlight={isHighlight(['p2WhomWhere'])}
                commentProps={{ 
                    commentLabel: '11.4.1 If yes, by whom and where ', 
                    commentStatus: null,
                }}
            >
                <CustomTextField
                    disableOnPermission={disableOnPermission}
                    key={`p2WhomWhere${siteInfoId}`}
                    label={'If yes, by whom and where'}
                    value={getSiteData('p2WhomWhere')}
                    debounceChange
                    name={'p2WhomWhere'}
                    maxLength={255}
                    onAppFieldValidate={updateSiteValidation}
                    updateSiteFormOnDisableChange={siteInfoId}
                    updateApplicationFormOnDisableChange={formId}
                    allowAction={getSiteData('p2OtherInvestigator') === true && isProspective}
                    onChange={onSiteFieldChange}
                />
            </NumberListFormItem>
        </SLayout>
    );
};

export default StudyDetailForProspectiveStudySiteInfo;
